import { render, staticRenderFns } from "./PriceList.vue?vue&type=template&id=3d3801be&"
import script from "./PriceList.vue?vue&type=script&lang=ts&"
export * from "./PriceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports